const translations = {
    legend: 'Legend'
};

export default translations;
